var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showLayoutHeader)?_c('HeaderBar'):_vm._e(),_c('router-view'),_c('NavigationBar'),_c('loader-item',{attrs:{"isLoader":this.$root.fullscreenLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }